import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SaleOption } from '@/features/opportunities/types';

export function useSaleOptions() {
  const { t } = useTranslation(['saleStatus']);

  const options = useMemo(
    () => [
      { label: t(`As is Sale`), value: 'as-is' as const },
      { label: t(`Ready to Build Sale`), value: 'rtb' as const },
      { label: t(`COD Sale`), value: 'cod' as const },
      { label: t(`Operational Sale`), value: 'operation' as const },
      { label: t(`Co-development`), value: 'co-development' as const },
      { label: t(`Debt Financing`), value: 'debt_financing' as const },
      { label: t(`PPA`), value: 'ppa' as const },
      { label: t(`TopCo Investment`), value: 'topco_investment' as const },
    ],
    [t]
  );

  const kv = useMemo(
    () => options.reduce((map, option) => ({ ...map, [option.value]: option.label }), {}) as Record<SaleOption, string>,
    [options]
  );

  const map = useCallback((value: SaleOption) => kv[value], [kv]);

  return { options, kv, map };
}
